function makeViewEvent(event: string) {
  return `Viewed: ${event}`;
}

function makeCompletedEvent(event: string) {
  return `Completed: ${event}`;
}

export default {
  VIEW: {
    CHECKOUT_APP: makeViewEvent('Check-out App')
  },
  CHECKOUT: {
    VALIDATION_PAGE: makeCompletedEvent('Checkout Validation Page'),
    CHECKOUT_DETAILS_PAGE: makeCompletedEvent('Checkout Details Page'),
    VIEW_BOL_PAGE: makeCompletedEvent('Checkout View BOL Page'),
    CHECKOUT_COMPLETE_PAGE: makeCompletedEvent('Checkout Complete Page')
  }
};
